
function updateAccessExpirationDateDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/update-access-expiration-date/update-access-expiration-date-dialog.html?$$REVISION$$'
  }
}

export { updateAccessExpirationDateDialog }
